import { Link } from "@heroui/react";
import { Globe2, Users } from "lucide-react";
import { useState } from "react";

import { InfoSection } from "./components/InfoSection";

const SiteFavicon = ({ sources }: { sources: string[] }) => {
  const [sourceIndex, setSourceIndex] = useState(0);
  const source = sources[sourceIndex];

  if (!source) {
    return (
      <Globe2
        aria-hidden="true"
        className="size-4 shrink-0 text-default-500"
      />
    );
  }

  return (
    <img
      alt=""
      aria-hidden="true"
      className="size-4 shrink-0 rounded-[3px]"
      decoding="async"
      loading="lazy"
      src={source}
      onError={() => setSourceIndex((index) => index + 1)}
    />
  );
};

export const InfoCommunity = () => {
  return (
    <InfoSection icon={Users} title="Community Links">
      <ul className="list-disc text-default-800 ml-10 flex flex-col gap-1 *:*:not-last:mr-1">
        <li>
          <Link
            className="inline-flex items-center gap-1.5"
            href="https://canvasstats.com"
            target="_blank"
          >
            <SiteFavicon
              sources={[
                "https://raw.githubusercontent.com/CanvasStats/main/cb3fac2a0a08dcd846a53e0946a85ece3e2807bf/public/icon.svg",
              ]}
            />
            CanvasStats.com
          </Link>
          <small>(@the_real_monte@sh.itjust.works)</small>
        </li>
        <li>
          <Link
            className="inline-flex items-center gap-1.5"
            href="https://chocolatecakecodes.goip.de/cotemplate/ui/template/20260520-Canvas26_main"
            target="_blank"
          >
            <SiteFavicon sources={[]} />
            CoTemplate
          </Link>
          <small>(@blued_gear@fedia.io)</small>
        </li>
        <li>
          <Link
            className="inline-flex items-center gap-1.5"
            href="https://2025.canvas-atlas.fediverse.events"
            target="_blank"
          >
            <SiteFavicon
              sources={[
                "https://2025.canvas-atlas.fediverse.events/_img/canvas-log-low-res.png",
              ]}
            />
            2025 Canvas Atlas
          </Link>
        </li>
      </ul>
    </InfoSection>
  );
};
